const BOOST_API_BASE_PATH = '/v3/boost';

export const BOOST_REDEEM_API_PATH = `${BOOST_API_BASE_PATH}/redeem`;
export const BOOST_DEBUG_GRANT_API_PATH = `${BOOST_API_BASE_PATH}/debug/grant`;
export const BOOST_QUEUE_API_PATH = `${BOOST_API_BASE_PATH}/queue`;
export const BOOST_REFERRALS_NOTIFIED_API_PATH = `${BOOST_API_BASE_PATH}/referrals/notified`;
